import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";

export const apartment = (props) => {
  return <ApartmentRoundedIcon {...props} />;
};
